export function formatSecondsToDDDHHMM(seconds) {
    const days = Math.floor(seconds / 86400);
    const hrs = Math.floor((seconds % 86400) / 3600);
    const mins = Math.floor((seconds % 3600) / 60);

    const dayStr = String(days).padStart(3, '0');
    const rest = [hrs, mins].map((v) => String(v).padStart(2, '0'));
    return [dayStr, ...rest].join(':');
}
